import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import type { ExpertiseArea } from '../types';

interface ExpertiseCardProps {
  expertise: ExpertiseArea;
  index: number;
}

const ExpertiseCard = ({ expertise, index }: ExpertiseCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -8, transition: { duration: 0.25 } }}
      className="glass-card rounded-2xl p-8"
    >
      <div className="w-16 h-16 bg-gradient-cta rounded-xl flex items-center justify-center mb-6 shadow-brand">
        <Icon name={expertise.icon} size={28} color="white" />
      </div>
      <h3 className="text-2xl font-bold text-white mb-4">
        {expertise.title}
      </h3>
      <p className="text-white/60 mb-6 leading-relaxed text-sm">
        {expertise.description}
      </p>
      <div className="space-y-2">
        {expertise.skills.map((skill, skillIndex) => (
          <div key={skillIndex} className="flex items-center gap-2">
            <Icon name="CheckCircle2" size={15} color="var(--color-accent)" />
            <span className="text-white/70 text-sm">{skill}</span>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default ExpertiseCard;